<app-blocked-nip-add
  [dialogRef]="dialogRef"
>
</app-blocked-nip-add>
